/*
 Controller used for the mobile initial lead guest screen
 */
/* global bookingApp, angular */
angular.module('bookingApp')
    .controller('leadGuestController', function ($scope, $http) {
    $scope.getPropertyPolicies = getPropertyPolicies;
    $scope.saveLeadGuests = saveLeadGuests;
    $scope.checkLeadGuestForm = checkLeadGuestForm;
    $scope.displayLeadGuestErrors = displayLeadGuestErrors;
    $scope.checkRoomGuestsForm = checkRoomGuestsForm;
    $scope.displayRoomGuestErrors = displayRoomGuestErrors;
    $scope.scrollToError = scrollToError;
    $scope.getCreditCardFee = getCreditCardFee;
    $scope.validateCustomFields = validateCustomFields;

    $scope.maxDOB = moment().subtract(1, 'year').format('YYYY-MM-DD');
    $scope.minDOB = moment().subtract(100, 'years').format('YYYY-MM-DD');

    if(!$scope.session.booking.leadGuest.dob) {
        $scope.session.booking.leadGuest.dob = null;
    } else {
        $scope.session.booking.leadGuest.dob = moment($scope.session.booking.leadGuest.dob).toDate();
    }

    $scope.setToDefaultDOB = function(){
        if($scope.session.booking.leadGuest.dob === null){
            $scope.session.booking.leadGuest.dob = moment().subtract(30, 'years').toDate();
        }
    };

    $scope.$watch('session.agreeTerms', checkTermsAgreed);
    $scope.$watch('session.customFields', checkCustomFields, true);
    $scope.$watch('session.booking.leadGuest', checkLeadGuestFormIsValid, true);

    $scope.getPaymentOptions = function() {
        var paymentOptions = $scope.session.paymentOptions;

        if (paymentOptions.hasOwnProperty(2)) { // Full payments
            // We remove full payments if the required deposit is the full payment
            if ($scope.getCartRoomTotal() === $scope.session.suggestedDeposit) {
                delete paymentOptions[2];
            }
        }

        return paymentOptions;
    };

    $scope.$watch('cart.insurance.chosen', function(){
        if($scope.cart.insurance.chosen){
            $scope.cart.insurance.amount = $scope.getInsurancePremium();
        }
    });



    $scope.paymentOptionCount = _.size($scope.getPaymentOptions());
    $scope.$watch('session.paymentOptions', function() {
        $scope.paymentOptionCount = _.size($scope.getPaymentOptions());
    });

    /**
     * Setup
     */
    $scope.getCreditCardFee();
    // loop through the rooms in the cart. and setup the guests per room
    $scope.cart.setupPlaceholdersForGuestDetails();
    // grab the property policies
    $scope.getPropertyPolicies();
    // setup footer control functionality
    if($scope.property.isItemOnly){
        $scope.setupItemOnlyFooter();
    } else {
        $scope.setupStandardCartFooter();
    }
    // next button need to watch the form validity before proceeding the user through to the next page.
    $scope.footer.nextFunc = nextFunc;

    function getPropertyPolicies(){
        $scope.session.isLoading = true;
        $http.get('/front-booking/api-get-policies',
            {
                params: {
                    bc: $scope.property.id,
                    sid: $scope.session.sid,
                    templateID: $scope.property.template.id,
                    limit: $scope.loadingLimit,
                    format: 'json'
                }
            }
        )
        .success(function(data, status, headers, config){
            $scope.property.policies = data.policies;
            $scope.session.isLoading = false;
        })
        .error(function(data, status, headers, config){
            $scope.logError('error retrieving policies',{status: status, headers: headers});
            // display error to the user
            $scope.showError('Whoops', 'It appears that there was an issue loading the policies. Please try again', true);
            $scope.session.isLoading = false;
        });
    }

    function saveLeadGuests(){
        $scope.session.leadGuestForm.previouslyHandled = true;
        $scope.session.isLoading = true;
        // loop through the cart and create a guest per room object
        var rooms = [];
        for(var room = 0, roomsCount = cart.rooms.length; room < roomsCount; room++){
            var selectedRoom = cart.rooms[room];
            var currentRoom = {};
            currentRoom.id = $scope.property.rooms[selectedRoom.id].id;
            currentRoom.bookableID = $scope.property.rooms[selectedRoom.id].bookable.id;
            currentRoom.bc = $scope.property.rooms[selectedRoom.id].bc;
            currentRoom.paxConfig = selectedRoom.paxConfig;
            currentRoom.customValues = selectedRoom.customValues;

            currentRoom.guestDetails = selectedRoom.guests;
            rooms.push(currentRoom);
        }

        if($scope.session.booking.leadGuest.dob) {
            $scope.session.booking.leadGuest.formattedDob = moment($scope.session.booking.leadGuest.dob).format('YYYY-MM-DD');
        }

        // run the ajax call
        $http.post('/front-booking/api-lead-guest/', {
            bc: $scope.property.id,
            sid: $scope.session.sid,
            device: 'mobile',
            templateID: $scope.property.template.id,
            format: 'json',
            leadGuestDetails: $scope.session.booking.leadGuest,
            customFields: $scope.session.customFields,
            customValues: $scope.session.bookingCustomValues,
            rooms: rooms,
            isDepositOrFullPayment: $scope.session.isDepositOrFullPayment
        }).success(function(data){
            $scope.session.payment = data.payment;
            $scope.session.isLoading = false;
            $scope.goToPage('payment');
        }).error(function(data, status, headers, config){
            if(headers('Insuranceleadguesterror') !== null && headers('Insuranceleadguesterror')){
                $scope.showError('Cannot Add Insurance', data.error, true);
            } else {
                $scope.logError('Error saving guest details', {status: status, headers: headers});
                $scope.showError('Couldn\'t Save', 'Not able to save the lead guest details, please try again. If the problem persists please refresh your browser', true);
            }
            $scope.session.isLoading = false;
        });
    }

    function checkLeadGuestForm(){
        var customFieldValid = $scope.validateCustomFields('guest');
        return $scope.mobileGuestForm.$valid && customFieldValid;
    }

    function displayLeadGuestErrors(){
        angular.forEach($scope.mobileGuestForm, function (value, key) {
            if (!value || value.$dirty === undefined) {
                return;
            } else {
                value.$setDirty();
            }
        });
    }

    function checkRoomGuestsForm(){
        var customFieldValid = $scope.validateCustomFields('room');
        return $scope.roomLeadGuests.$valid && customFieldValid;
    }

    function displayRoomGuestErrors(){
        angular.forEach($scope.roomLeadGuests, function(value, key){
            if(!value || value.$dirty === undefined){
                return;
            }else{
                value.$setDirty();
            }
        });
    }

    function scrollToError(){
        if(typeof $('.sk-input-group.has-error').position() !== 'undefined')
        {
            if(typeof $('.sk-input-group.has-error').position().top !== 'undefined') {
                var errorY = $('.sk-input-group.has-error').position().top;
                $('html, body').stop().animate({scrollTop: (errorY - 50)});
            }
        }
    }


        $scope.$watch('cart.insurance.chosen', function(){
            if($scope.propertyOffersInsurance()){
                if(typeof $scope.cart.insurance.chosen === 'boolean') {
                    $scope.session.insuranceError = false;
                }
            }
        });


    function nextFunc(){
        var leadGuestValidated = $scope.checkLeadGuestForm();
        var roomGuestsValidated = $scope.checkRoomGuestsForm();
        if($scope.propertyOffersInsurance()){
            // check the user has selected a valid option
            if(typeof $scope.cart.insurance.chosen !== 'boolean'){
                // highlight the checkboxes and scroll to this
                $scope.session.insuranceError = true;
                if(typeof $('.sk-insurance.has-error').position() !== 'undefined'){
                    if(typeof $('.sk-insurance.has-error').position().top !== 'undefined'){
                        var errorY = $('.sk-insurance.has-error').position().top;
                        $('html, body').stop().animate({scrollTop: (errorY - 50)});
                        return;
                    }
                }
                return;
            }
        }
        // ensure that address fields are showing so the user can see the address error messages
        $scope.session.booking.leadGuest.addressShow = true;
        if(leadGuestValidated && roomGuestsValidated){
            $scope.saveLeadGuests();
        } else {
            $scope.displayLeadGuestErrors();
            $scope.displayRoomGuestErrors();
            $scope.scrollToError();
        }
    }

    /**
     * watchers
     */

    function checkTermsAgreed(newVal, oldVal){
        if($scope.property.policies.hasOwnProperty('Cancellation Policy') || $scope.property.policies.hasOwnProperty('Check In Policy') || $scope.property.policies.hasOwnProperty('Child Policy') || $scope.property.policies.hasOwnProperty('Payment Policy')){
            if(!(typeof session.agreeTerms === 'undefined')){
                $scope.mobileGuestForm.$setValidity('agreeTerms', true);
            } else {
                $scope.mobileGuestForm.$setValidity('agreeTerms', false);
            }
        }
    }

    function checkCustomFields(newVal, oldVal){
        // check that the checkboxes in the custom fields that are mandatory are checked
        for(var field = 0, fields = session.customFields.length; field < fields; field++){
            if(((session.customFields[field].isMandatory) && (session.customFields[field].fieldType === 3))){
                if(!session.customFields[field].value){
                    // set form to invalid
                    $scope.mobileGuestForm.$setValidity('customField'+field, false);
                }else{
                    $scope.mobileGuestForm.$setValidity('customField'+field, true);
                }
            }
        }
    }

    function checkLeadGuestFormIsValid(newVal, oldVal) {
        // check if the lead guest for is valid and set the session variable for the footer control
        if (($scope.checkLeadGuestForm() && $scope.mobileGuestForm.$dirty) || ($scope.checkLeadGuestForm() && $scope.session.leadGuestForm.previouslyHandled)) {
            session.leadGuestForm.isValid = $scope.checkLeadGuestForm();
        } else {
            session.leadGuestForm.isValid = false;
        }
        // update the room guest details based on the guest details of the first name / last name
        if($scope.cart.rooms.length > 0) {
            var guests = $scope.cart.rooms[0].guests,
                pax;

            pax = guests.adults.length ? guests.adults[0] : (guests.children.length ? guests.children[0] : (guests.infants.length ? guests.infants[0] : {}));
            if (newVal.lastName !== oldVal.lastName) {
                pax.lastName = newVal.lastName;
            }
            if (newVal.firstName !== oldVal.firstName) {
                pax.firstName = newVal.firstName;
            }
        }
    }

    function getCreditCardFee(){
        $http.post('/front-booking/api-get-credit-card-fee', {
            bc: $scope.property.id,
            sid: $scope.session.sid,
            device: 'mobile',
            templateID: $scope.property.template.id,
            format: 'json',
        }).success(function(data) {
            $scope.session.captureCreditCard = data.captureCreditCard;
            $scope.session.creditCardFee = data.creditCardFee;
        }).error(function(data){

        });
    }


    /**
     * Validate all custom fields input
     * @returns {boolean}
     */
    function validateCustomFields(type){
        var isValid = true,
            guestForm = $scope.mobileGuestForm,
            roomForm = $scope.roomLeadGuests;

        if(type === 'room') {
            guestForm = false;
        }
        if(type === 'guest') {
            roomForm = false;
        }

        if(guestForm) {
            angular.forEach($scope.session.bookingCustomFields, function(customField){
                var customFieldSubForm = guestForm['customField' + customField.id],
                    customFieldModel, value;
                if (typeof customFieldSubForm !== 'undefined') {
                    customFieldModel = customFieldSubForm['customField' + customField.id];
                    customFieldSubForm.$setDirty(true);
                    if(typeof customFieldModel !== 'undefined'){
                        customFieldModel.$setDirty(true);
                        value = customFieldModel.$viewValue;
                        if(typeof value === 'undefined' || value === null) {
                            value = '';
                        }

                        angular.forEach(customFieldModel.$parsers, function(parsers){
                            parsers(value);
                        });

                        customFieldModel.$invalid;
                        if(isValid){
                            isValid = (customFieldModel.$invalid !== true);
                        }
                        customFieldModel.$render();
                    }
                }
            });
        }

        if(roomForm) {
            angular.forEach(cart.rooms, function(room, index){
                angular.forEach(room.roomDetails.customFields, function(customField){
                    var customFieldSubForm = roomForm['room' + index + 'customField' + customField.id],
                        customFieldModel, value;
                    if(typeof customFieldSubForm !== 'undefined') {
                        customFieldModel = customFieldSubForm['room' + index + 'customField' + customField.id];
                        customFieldSubForm.$setDirty(true);
                        if(typeof customFieldModel !== 'undefined'){
                            customFieldModel.$setDirty(true);
                            value = customFieldModel.$viewValue;
                            if(typeof value === 'undefined' || value === null) {
                                value = '';
                            }

                            angular.forEach(customFieldModel.$parsers, function(parsers){
                                parsers(value);
                            });

                            customFieldModel.$invalid
                            if(isValid){
                                isValid = customFieldModel.$valid;
                            }
                            customFieldModel.$render();
                        }
                    }
                });
            });
        }

        return isValid;
    }
});
